import React from 'react';
import { Button, Typography } from 'antd';
import { NavLink } from 'react-router-dom';

export interface FooterProps {
  setSignInOpen?: () => void;
  signUpClose?: () => void;
}

function Footer({
  setSignInOpen,
  signUpClose,
}: FooterProps): React.ReactElement {
  return (
    // <Typography.Text strong style={{ textAlign: 'center', display: 'block', width: '100%' }}>
    //   Do you have an account? &thinsp;
    //   <NavLink to="/sign-in">
    //     Sign In
    //   </NavLink>
    // </Typography.Text>
    <div>
      <Typography.Text
        style={{
          textAlign: 'center',
          display: 'block',
          width: '100%',
          fontSize: '17px',
          fontWeight: 300,
        }}
      >
        By continuing, you agree to our&thinsp;
        <NavLink
          to="/terms-and-conditions"
          style={{
            color: '#040404',
            fontWeight: '700',
            textDecoration: 'underline',
          }}
        >
          User Agreement
        </NavLink>
      </Typography.Text>
      <Typography.Text
        style={{
          textAlign: 'center',
          display: 'block',
          width: '100%',
          fontSize: '17px',
          fontWeight: 300,
        }}
      >
        and acknowledge that you understand the
        <br />
        <NavLink
          to="/privacy-policy"
          style={{
            color: '#040404',
            fontWeight: '700',
            textDecoration: 'underline',
          }}
        >
          Privacy Policy.
        </NavLink>
      </Typography.Text>
      <Typography.Text
        style={{
          textAlign: 'center',
          display: 'block',
          width: '100%',
          fontSize: '17px',
          fontWeight: 300,
          marginTop: '20px',
        }}
      >
        Already have an account? &thinsp;
        {/* <NavLink to="/sign-up" style={{ color: '#040404', fontWeight: '700', textDecoration: 'underline' }}>
          Register
        </NavLink> */}
        <Button
          type="link"
          onClick={(e) => {
            e.stopPropagation();
            signUpClose?.();
            setSignInOpen?.();
          }}
          style={{
            color: '#040404',
            fontWeight: '700',
            padding: '0',
            textDecoration: 'underline',
          }}
        >
          Login
        </Button>
        {/* <SignUp
          content={EmailAndPassword}
          isOpen={isSignUpOpen}
          onClose={() => setSignUpOpen?.(false)}
          onSignInClose={onSignInClose}
        /> */}
      </Typography.Text>
    </div>
  );
}

export default Footer;
